import React from 'react';
import CorsTester from './CorsTester';

function App() {
  return (
    <div className="App">
      <CorsTester />
    </div>
  );
}

export default App;
